import cn from 'classnames';
import React, { FC, ReactNode } from 'react';

import { ButtonDetail } from '@/components/modules/orders-page/orders/ui/body/button-detail';
import { TProductItemConfig } from '@/components/modules/orders-page/orders/ui/product-item';
import { RentDate } from '@/components/modules/orders-page/orders/ui/rent-date';
import { EOrderStatus, OrderDateRentModel } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Button } from '@/shared/ui/button';
import { ShowContentByBreakPoint } from '@/shared/ui/show-by-breakpoint';

import * as Styled from './styled';

type TProps = {
    config: TProductItemConfig;
    dateRent?: OrderDateRentModel;
    children?: ReactNode;
    isLoading?: boolean;
    onExtendRent?: () => void;
    onModalDetailsPayment: () => void;
    onModalCalendarPayment: () => void;
};

export const WrapperDetailInfo: FC<TProps> = ({
    isLoading,
    config,
    onExtendRent,
    dateRent,
    children,
    onModalDetailsPayment,
    onModalCalendarPayment,
}) => {
    const { t } = useTranslate();

    function getButtonText(config: TProductItemConfig) {
        if (config.status === EOrderStatus.Sent_to_court) {
            return 'Оплатить';
        }

        if (config.termUnit === 1) {
            return 'Продлить аренду';
        } else {
            return 'Оплатить очередной платеж';
        }
    }

    if (config.status === 'closed') {
        return (
            <div className={cn('data', config.status)}>
                {dateRent && <RentDate dateRent={dateRent} status={config.status} />}
                <ShowContentByBreakPoint showIf="md">
                    <ButtonDetail
                        config={config}
                        onModalDetailsPayment={onModalDetailsPayment}
                        onModalCalendarPayment={onModalCalendarPayment}
                    />
                </ShowContentByBreakPoint>
            </div>
        );
    }

    return (
        <Styled.Wrapper>
            <Styled.Info>
                {dateRent && (config.termUnit === 1 || config.status === EOrderStatus.Sent_to_court) && (
                    <RentDate dateRent={dateRent} status={config.status} />
                )}
                {children}
            </Styled.Info>
            <ShowContentByBreakPoint showIf="md">
                <ButtonDetail
                    config={config}
                    onModalDetailsPayment={onModalDetailsPayment}
                    onModalCalendarPayment={onModalCalendarPayment}
                />
            </ShowContentByBreakPoint>
            <Styled.ButtonBox status={config.status} onClick={onExtendRent}>
                <Button isLoading={isLoading} variant="primary" aria-label={t(getButtonText(config))}>
                    {t(getButtonText(config))}
                </Button>
            </Styled.ButtonBox>
        </Styled.Wrapper>
    );
};
